import { useState } from "react";

interface SidebarProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
}

const navItems = [
  { id: "dashboard", label: "Dashboard", icon: "ri-layout-grid-line" },
  { id: "clients", label: "Müşteri Yönetimi", icon: "ri-user-star-line" },
  { id: "calendar", label: "Randevu Takvimi", icon: "ri-calendar-star-line" },
  { id: "services", label: "Hizmet Yönetimi", icon: "ri-sparkling-line" },
  { id: "tracking", label: "İş Takip Paneli", icon: "ri-briefcase-4-line" },
];

export default function Sidebar({ activeSection, onSectionChange }: SidebarProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside
      className={`relative flex flex-col transition-all duration-300 ${collapsed ? "w-16" : "w-64"} shrink-0`}
      style={{
        background: "linear-gradient(180deg, #2a2260 0%, #1e1840 100%)",
        borderRight: "1px solid rgba(212,175,55,0.25)",
      }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3 px-4 py-5 border-b" style={{ borderColor: "rgba(212,175,55,0.2)" }}>
        <div className="w-9 h-9 shrink-0 rounded-full overflow-hidden flex items-center justify-center">
          <img
            src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/fdfaa79e27fe73befd4dae46aa58b8a6.png"
            alt="Logo"
            className="w-full h-full object-cover"
          />
        </div>
        {!collapsed && (
          <div className="overflow-hidden">
            <p className="text-sm font-semibold whitespace-nowrap" style={{ color: "#d4af37", fontFamily: "'Playfair Display', serif" }}>
              AstroPanel
            </p>
            <p className="text-xs whitespace-nowrap" style={{ color: "rgba(255,255,255,0.4)" }}>
              Danışmanlık Sistemi
            </p>
          </div>
        )}
      </div>

      {/* Nav Items */}
      <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => {
          const isActive = activeSection === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onSectionChange(item.id)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg cursor-pointer transition-all duration-200 group whitespace-nowrap ${
                isActive
                  ? "text-white"
                  : "text-white/60 hover:text-white/90 hover:bg-white/[0.06]"
              }`}
              style={
                isActive
                  ? {
                      background: "linear-gradient(135deg, rgba(168,85,247,0.4) 0%, rgba(212,175,55,0.2) 100%)",
                      border: "1px solid rgba(212,175,55,0.4)",
                    }
                  : { border: "1px solid transparent" }
              }
            >
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i
                  className={`${item.icon} text-base`}
                  style={{ color: isActive ? "#d4af37" : undefined }}
                />
              </div>
              {!collapsed && (
                <span className="text-sm font-medium" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {item.label}
                </span>
              )}
              {isActive && !collapsed && (
                <div className="ml-auto w-1.5 h-1.5 rounded-full shrink-0" style={{ background: "#d4af37" }} />
              )}
            </button>
          );
        })}
      </nav>

      {/* Bottom section */}
      <div className="px-2 py-4 border-t" style={{ borderColor: "rgba(212,175,55,0.15)" }}>
        <div className={`flex items-center gap-3 px-3 py-2.5 rounded-lg ${collapsed ? "justify-center" : ""}`}
          style={{ background: "rgba(255,255,255,0.04)" }}>
          <div className="w-8 h-8 rounded-full flex items-center justify-center shrink-0 text-xs font-bold"
            style={{ background: "linear-gradient(135deg, #a855f7, #d4af37)", color: "#fff" }}>
            AS
          </div>
          {!collapsed && (
            <div className="overflow-hidden">
              <p className="text-sm font-medium text-white/80 whitespace-nowrap">Astrolog</p>
              <p className="text-xs whitespace-nowrap" style={{ color: "#d4af37" }}>Pro Üye</p>
            </div>
          )}
        </div>
      </div>

      {/* Collapse Toggle */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="absolute -right-3 top-7 w-6 h-6 rounded-full flex items-center justify-center cursor-pointer transition-all hover:scale-110 z-10"
        style={{ background: "#2a2260", border: "1px solid rgba(212,175,55,0.5)" }}
      >
        <div className="w-3 h-3 flex items-center justify-center">
          <i
            className={`${collapsed ? "ri-arrow-right-s-line" : "ri-arrow-left-s-line"} text-xs`}
            style={{ color: "#d4af37" }}
          />
        </div>
      </button>
    </aside>
  );
}
